import { useMyOrg } from '../layouts/AppStateContextLayout/utils'

export const useIsInspectionSchedulingWithTimesEnabled = () => {
  const myOrg = useMyOrg()
  return myOrg?.inspectionSchedulingType === 'DateAndTime'
}
